export default __webpack_public_path__ + "static/media/picsure_logo.2e6b4bc5.svg";